export default __webpack_public_path__ + "static/media/maliha_story_3.d93a99d1.jpg";